import axios from "axios";

export const getDepots = async ({ query = {}, provider, includeDeleted = false, controller = null, excludeInterceptor = false }: any) => {	
	const params: any = {params : { ...query, ...(includeDeleted ? { withDeleted: true } : {}) }, excludeInterceptor}
	if(controller?.signal){
		params.signal = controller.signal
	}

	try {
		const res: any = await axios.get(`/providers/${provider.id}/depots`, params);
		return res?.data ? res.data : [];
	} catch (e: any) {
		return [];
	}
};

export const getAllDepots = async ({ query = {}, provider, controller = null, excludeInterceptor = false }: any) => {	
	const params: any = {params : query, excludeInterceptor}
	if(controller?.signal){
		params.signal = controller.signal
	}

	try {
		const res: any = await axios.get(`/depots`, params);
		return res?.data ? res.data : [];
	} catch (e: any) {
		return [];
	}
};

export const getDepot = async ({ data, provider, controller = null}: any) => {	
	try {
		const res: any = await axios.get(`/providers/${provider.id}/depots/${data?.id}`);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const createDepot = async ({ provider, create }: any) => {
	try {
		const res: any = await axios.post(`/providers/${provider.id}/depots`, create);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const updateDepot = async ({ provider, data, update }: any) => {
	try {
		const res: any = await axios.put(`/providers/${provider.id}/depots/${data?.id}`, update);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};


export const deleteDepot = async ({ provider, data, update }: any) => {
	try {
		const res: any = await axios.delete(`/providers/${provider.id}/depots/${data?.id}`, update);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const restoreDepot = async ({ provider, data }: any) => {
	try {
		const res: any = await axios.post(`/providers/${provider.id}/depots/${data?.id}/restore`);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const createDepotComboProduct = async ({ data, create }: any) => {
	try {
		const res: any = await axios.post(`/providers/${data.providerId}/depots/${data.depotId}/combo-products`, create);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const getDepotComboProducts = async ({ data }: any) => {	
	try {
		const res: any = await axios.get(`/providers/${data.providerId}/depots/${data.depotId}/combo-products`);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const updateDepotProductCombo = async ({ data, update }: any) => {
	try {
		const res: any = await axios.put(`/providers/${data?.providerId}/depots/${data?.id}/combo-products/${data?.itemId}`, update);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const deleteDepotComboProduct = async ({ data }: any) => {
	try {
		const res: any = await axios.delete(`/providers/${data?.providerId}/depots/${data?.id}/combo-products/${data?.itemId}`);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};
